import { useRef } from "react";
import { styled } from "styled-components";

import { HiddenImageUpload, UIButton } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { uploadImage } from "domains/collection/actions";
import type { LocalFile } from "domains/createMapDetail/types";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";

const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.textBright};
`;

export const CollectionHeroImagePickerModal = () => {
  const dispatch = useDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const translate = useTranslate();

  const onSetImage = ({ url }: LocalFile) => {
    dispatch(uploadImage({ image: url, type: "collection" }));
    dispatch(deactivateModal());
  };

  return (
    <>
      <ModalHeader title={translate("app.create.collection.modal.change_background_image")} />
      <StyledTitle>{translate("app.create.create_map.add_image")}</StyledTitle>
      <HiddenImageUpload accept="image/*" onSetImage={onSetImage} ref={inputRef} />
      <UIButton fullwidth onClick={() => inputRef.current?.click()} variant="filled">
        {translate("app.profile.upload_image.title")}
      </UIButton>
    </>
  );
};
